define('AAMS.OffersExtension.Offers.Mobile.View'
    , [
          'aams_offersextension_offers_mobile_panel.tpl'
        , 'Profile.Model'
        , 'Utils'
        , 'Backbone.View'
        , 'Backbone.FormView'
        , 'Backbone.CompositeView'
        , 'AAMS.OffersExtension.Offers.SignUp.Model'
        , 'GlobalViews.Message.View'
        , 'AAMS.OffersExtension.Offers.Countries.View'
        , 'AjaxRequestsKiller'
        , 'AAMS.OffersExtension.Offers.Mobile.Success.View'
    ],
    function (
          aams_offersextension_offers_mobile_panel_tpl
        , ProfileModel
        , Utils
        , BackboneView
        , BackboneFormView
        , BackboneCompositeView
        , OffersSignupModel
        , GlobalViewsMessageView
        , CountriesView
        , AjaxRequestsKiller
        , OffersMobileSuccessView 

    ) {
        'use strict';
        return Backbone.View.extend({

            template: aams_offersextension_offers_mobile_panel_tpl,

            modalClass: 'offers-popup-modal',
            attributes: {
                id: 'offers-popup-mobile'
            },   

            initialize: function (options) {
                this.options = options;
                this.application = options.application;
                var profile = ProfileModel.getInstance()
                    , is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

                this.profile = profile;
                //this.userId=profile.get('internalid');
                this.is_logged_in=is_logged_in;
                this.model = options.model || new OffersSignupModel();
                this.countries = this.application.configuration.get('siteSettings.countries', []);
                this.userInfo = options.userInfo;
                
                BackboneFormView.add(this);
            },
           /* bindings: {
                '[name="firstname"]': 'firstname',
                '[name="lastname"]': 'lastname',
                '[name="phone"]': 'phone',
                '[name="email"]': 'email',
                '[name="custentity_destination_country"]': 'custentity_destination_country',
                '[name="custentity_customer_state"]': 'custentity_customer_state'
            },*/
            childViews: {
                'Offers.Countries.Dropdown': function() {
                    //console.log(this.countries)
                    if(this.userInfo && this.userInfo.custentity_destination_country)
                        this.selectedCountry =  this.userInfo.custentity_destination_country;

                    return new CountriesView({
                        countries: this.countries,
                        selectedCountry: this.selectedCountry,
                        manage: this.options.manage
                    });
                }
            },
            events: {
                'submit form': 'submitForm',
                'click [data-action="hide-rightside-offers"]': 'hideSidebar',
                'click [data-action="show-offers"]': 'showOffers',
                'click [data-action="show-weekly-deals"]': 'showWeeklyDeals',
                'click [data-action="show-clearance-items"]': 'showClearanceItems',
                'change [data-action="product-interests-checked"]': 'subscribeIndividualPreferences',
                'change [data-action="individual-subscribe"]': 'subscribeIndividualPreferences',
                'click [data-action="offers-check-button"]': 'clickOffersCheckButton',
                'click [data-action="offers-check-button-sl"]': 'subscribeAllEmailPreferences',

                
            },
            render: function(){
                var userid = this.profile.get('internalid')
                var self = this;

                if(this.is_logged_in)
                {
                    this.model.fetch({
                        data: {
                            internalid: userid,
                            getExistingCustomerDetails:"T"
                        },
                        killerId: AjaxRequestsKiller.getKillerId()
                    }).done(function(result) {
                            if(result.user)
                                self.userInfo = result.user[0];              
                            self._render();
                    });
                }
                else
                {
                    self._render();
                }
                //this._render();
            },
            hideSidebar: function hideSidebar(e) {
                var dontCloseFlag = false;

                if (e.target.tagName === 'A') {
                    if (this.activeLink) {
                        this.activeLink.removeClass('active');
                    }
                    this.activeLink = jQuery(e.target);
                    this.activeLink.addClass('active');
                } else if (e.target.tagName === 'SPAN') {
                    dontCloseFlag = true;
                }

                if (dontCloseFlag == false) {
                    jQuery('.main').removeClass('offers-rightside-bar-opened');
                    jQuery('.offers-sidebar-close-rightside-bar').hide();
                    jQuery('.header-secondary-wrapper-mobile').show();
                    jQuery('.shopping-layout-header').css("box-shadow", "rgb(153, 153, 153) 0px 1px 10px")
                    jQuery('.offers-sidebar-overlay-sec').hide();
                    jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
                    jQuery('.myaccount-layout-header').addClass('myaccount-layout-header-no-hamburger-scroll')
                }
            },
            clickOffersCheckButton:function clickOffersCheckButton(e){
                var self =this;
                var currentTarget = $(e.currentTarget)
                ,   currentTargetAttr = currentTarget.attr('data-attr')
                ,   currentTargetClass = currentTarget.attr('class')
                currentTarget.hide()
                
                if(currentTargetClass=="offers-plus-icon")
                    jQuery('.offers-check-icon[data-attr='+currentTargetAttr+']').show();
                else
                    jQuery('.offers-plus-icon[data-attr='+currentTargetAttr+']').show();
                    
                self.subscribeIndividualPreferences(currentTargetAttr);
                
                //self.subscribeAllEmailPreferences(currentTargetAttr);
                
            },
            showOffers: function showOffers(e) {
              jQuery('.offers-content').show();
              jQuery('.offers-weekly-deals-content').hide();
              jQuery('.offers-clearance-content').hide();

            },
            showWeeklyDeals: function showWeeklyDeals(e) {
            	jQuery('.offers-weekly-deals-content').show();
            	jQuery('.offers-clearance-content').hide();
            	jQuery('.offers-content').hide();
            },
            showClearanceItems: function showClearanceItems(e) {
				jQuery('.offers-clearance-content').show();
				jQuery('.offers-weekly-deals-content').hide();
				jQuery('.offers-content').hide();
			},
            submitForm: function (e) {
                e.preventDefault();
                const self = this;
                jQuery('#in-modal-register-email').prop('disabled', false);
                const data = (jQuery(e.target).closest('form')).serializeObject();
                const promise = this.saveForm(e);

                const container = self.$containerModal;
                var Layout = self.options.application.getComponent('Layout');

                if (promise) {
                    jQuery('#in-modal-submit-newsletter-form').text('Processing...');
                    jQuery('#in-modal-register-email').prop('disabled', true);
                    jQuery('#in-modal-submit-newsletter-form').attr('disabled', 'disabled');
                    promise
                        .fail(function (jqXhr) {
                            //console.log(jqXhr)
                            jQuery('.newsletter-alert-placeholder')
                            .html("<div class='global-views-message global-views-message-success alert' role = 'alert'><div>Sorry, subscription cannot be updated. Try again later.</div></div>");
                        })
                        .done(function (res) {
                           // console.log(res)
                            if (res.code == 'OK') 
                            {
                            	/*var $alert_placeholder = jQuery('.offers-success-placeholder');
                        	    const message = Utils.translate(
					                '<p>You are now subscribed to AA Medical Offers. Look out for updates on weekly deals, new arrivals, and more!</p>'
					            );
					            const global_view_message = new GlobalViewsMessageView({
					                message: message,
					                type: 'success',
					                closable: false
					            });

                            	global_view_message.show($alert_placeholder,8000);*/
                                //alert('Success');

                                var Layout = self.application.getComponent('Layout');
                                //console.log(Layout)

                                var view = new OffersMobileSuccessView({
                                    application: Layout.application
                                });

                                if (view)
                                Layout.showContent(view, {showInModal: true});

                                jQuery('#in-modal-submit-newsletter-form').text('Submit')
                            }
                            else
                            {
                                alert('Sorry Please Try Again after some time')
                            }
                        })
                }
            },
            subscribeIndividualPreferences: function(target){
                var self =this;
                var currentTarget = jQuery('#in-modal-'+target);
		        var currentTargetProp = currentTarget.prop('checked')
                var currentTargetName = currentTarget.attr('name');
                if(currentTargetProp == true){
		           currentTarget.attr('checked',false);
		           currentTarget.attr('value', ''); 
                   self.model.set(currentTargetName,"");
		        }
		        else{
		            currentTarget.attr('checked',true);
 		            currentTarget.attr('value', 'T'); 
                    self.model.set(currentTargetName,"T");

		        }
                if(true)
                {
                    if($(".email-preferences-body input[type=checkbox]:checked:not(#in-modal-email-preferences-subscribe-all)").length<5)
                    {
                        jQuery('#in-modal-offers-sl-check-icon').hide()
                        jQuery('#in-modal-offers-sl-plus-icon').show()
                        jQuery('.email-preferences-subscribe-all').attr("checked", false);
                        jQuery('.email-preferences-subscribe-all').attr("value", ""); 
                        self.model.set('custentity_mc_opt_in',"");
                    }    
                }
                
                /*else if($(".email-preferences-body input[type=checkbox]:checked").length == 6)
                { 
                    jQuery('#offers-sl-check-icon').show();
                    jQuery('#offers-sl-plus-icon').hide();
                    jQuery('.email-preferences-subscribe-all').prop("checked", true);
                }*/
		    },
		    subscribeAllEmailPreferences: function subscribeAllEmailPreferences(e){
                var self =this;
                var currentTarget = jQuery('.email-preferences-subscribe-all');
		        var currentTargetProp = currentTarget.prop('checked')
                if(currentTargetProp == true)
		        {
                    $(".email-preferences-body input[type=checkbox]").attr('checked',false);
                    $(".email-preferences-body input[type=checkbox]").attr('value', '');
                    jQuery('.email-preferences-section .offers-check-icon').hide();
                    jQuery('.email-preferences-section .offers-plus-icon').show(); 
                    jQuery(".email-preferences-body input[type=checkbox]").each(function () {
                        const name = jQuery(this).attr("name");     // Get the name attribute
                        self.model.set(name,"");
                    }); 
		        }
		        else if(currentTargetProp == false)
		        {
		           
                    $(".email-preferences-body input[type=checkbox]").attr('checked',true);
                    $(".email-preferences-body input[type=checkbox]").attr('value', 'T');
                    jQuery('.email-preferences-section .offers-check-icon').show()
                    jQuery('.email-preferences-section .offers-plus-icon').hide() 
                    jQuery(".email-preferences-body input[type=checkbox]").each(function () {
                        const name = jQuery(this).attr("name");     // Get the name attribute
                        self.model.set(name,"T");
                    }); 
		        }
		    },
		    getContext: function getContext() {
                var self =this;
                var email="",internalid="",userId="",userFname="",userLname="",optin = "";
                var weekly_deals_enabled = false
                    , make_an_offer_enabled = false
                    , new_arrivals_enabled = false
                    , recommended_for_you_enabled = false
                    ,   arthroscopy_enabled = false
                    ,   laproscopy_enabled = false
                    ,   urology_enabled = false
                    ,   gyn_enabled = false
                    ,   ent_enabled = false
                    ,   orthopedic_enabled = false
                    ,   neurology_enabled = false
                    ,   visualization_enabled = false
                    ,   flexible_endoscopy_enabled = false
                    ,   patient_care_enabled = false
                    ,   imaging_enabled = false
                    ,   surgical_power_enabled = false
                    ,   sports_medicine_enabled = false
                    ,   urology_gyno_enabled  =false  
                    ,   product_of_the_week_enabled = false
                    //,   deal_of_the_week_enabled = false  // Deal of the Week - Commented Out
                
                if(this.userInfo)
                {
                    var emailPreferencesArray = this.userInfo.emailpreferences
                    var productInterestsArray = this.userInfo.productinterests

                    optin =this.userInfo.optin;
                    email = this.userInfo.email;
                    userFname = this.userInfo.firstname;
                    userLname = this.userInfo.lastname;
                    userId =this.userInfo.internalid;

                    if(emailPreferencesArray)
                    var splitEmailPreferencesArray = emailPreferencesArray.split(',')

                    //console.log(splitEmailPreferencesArray)

                    if(emailPreferencesArray){
                        _.each(splitEmailPreferencesArray,function(line){
                            if(line == '1'){
                                weekly_deals_enabled = true;
                            }
                            if(line == '101'){
                                make_an_offer_enabled = true;
                            }
                            if(line == '102'){
                                new_arrivals_enabled = true;
                            }
                            if(line == '103'){
                                recommended_for_you_enabled = true;
                            }
                            if(line == '113'){
                                product_of_the_week_enabled = true;
                            }
                            // Deal of the Week - Commented Out
                            // if(line == '114'){
                            //     deal_of_the_week_enabled = true;
                            // }
                        });
                    }
                    
                    if(productInterestsArray)
                    var splitProductInterestsArray = productInterestsArray.split(',')

                    if(productInterestsArray){
                         _.each(splitProductInterestsArray,function(pi){
                            if(pi == '1'){
                                arthroscopy_enabled = true;
                            }
                            if(pi == '2'){
                                laproscopy_enabled = true;
                            }
                            if(pi == '3'){
                                urology_enabled = true;
                            }
                            if(pi == '5'){
                                gyn_enabled = true;
                            }
                            if(pi == '6'){
                                ent_enabled = true;
                            }
                            if(pi == '7'){
                                orthopedic_enabled = true;
                            }
                            if(pi == '9'){
                                neurology_enabled = true;
                            }
                            if(pi == '12'){
                                visualization_enabled = true;
                            }
                            if(pi == '14'){
                                flexible_endoscopy_enabled = true;
                            }
                            if(pi == '16'){
                                patient_care_enabled = true;
                            }
                            if(pi == '18'){
                                imaging_enabled = true;
                            }
                            if(pi == '33'){
                                surgical_power_enabled = true;
                            }
                            if(pi == '34'){
                                sports_medicine_enabled = true;
                            }
                        });
                    }
                }
                //console.log('userId --- '+userId)
                var subscribeAll = false;
                
                if(optin == 'T')
                    subscribeAll = true
                if(userId == "")
                    subscribeAll = true

                if(subscribeAll)
                {   
                    recommended_for_you_enabled = true;
                    weekly_deals_enabled = true;
                    new_arrivals_enabled = true;
                    product_of_the_week_enabled = true;
                    //deal_of_the_week_enabled = true;  // Deal of the Week - Commented Out
                    
                }
                if(urology_enabled == true || gyn_enabled == true)
                    urology_gyno_enabled =true;
                
                return {
                    isPhoneDevice: Utils.isPhoneDevice(),
                    userId :userId || "",
                    is_logged_in:self.is_logged_in,
                    userEmail : email,
                    userFname : userFname,
                    userLname : userLname,
                    subscribeAll : subscribeAll,
                    newSubscriber : userId == "" ? true : false,
                    isPhoneDevice : Utils.isPhoneDevice(),
                    weeklyDeals : weekly_deals_enabled,
                    makeAnOffer : make_an_offer_enabled,
                    newArrivals : new_arrivals_enabled,
                    recommendedForYou : recommended_for_you_enabled,
                    arthroscopy_enabled : arthroscopy_enabled,
                    laproscopy_enabled : laproscopy_enabled,
                    urology_enabled : urology_enabled,
                    gyn_enabled : gyn_enabled,
                    ent_enabled : ent_enabled,
                    orthopedic_enabled : orthopedic_enabled,
                    neurology_enabled : neurology_enabled,
                    visualization_enabled : visualization_enabled,
                    flexible_endoscopy_enabled : flexible_endoscopy_enabled,
                    patient_care_enabled : patient_care_enabled,
                    imaging_enabled : imaging_enabled,
                    surgical_power_enabled : surgical_power_enabled,
                    sports_medicine_enabled : sports_medicine_enabled,
                    urology_gyno_enabled : urology_gyno_enabled,
                    //deal_of_the_week_enabled : deal_of_the_week_enabled,  // Deal of the Week - Commented Out
                    product_of_the_week_enabled : product_of_the_week_enabled
                };
            }
        });
    });
